export { Wrapper, iconSizeMap, Icon, iconsList } from "./Icon";